import { logger } from "@/utils/logger"
import type { CONFIG as CONFIG_TYPE } from "./types"

const API_CONFIG: CONFIG_TYPE = {
	student_dashboard_origins: [
		// QA STUDENT PORTALS
		"qa.jntu.thekaios.com",
		"qa.aditya.thekaios.com",
		"qa.aditya.usdcglobal.com",

		// UAT STUDENT PORTALS
		"uat.stanford.thekaios.com",
		"uat.hogwarts.thekaios.com",

		// PROD STUDENT PORTALS
		"portal.onlineaju.ac.in",
		"humversity.usdcglobal.com",
		"portal.onlinejain.com",
		"portal.shardaonline.ac.in",
		"portal.vignanonline.com",
		"portal.onlineyenepoya.com",
		"portal.cfs.onlinejain.com",
		"nitk.usdcglobal.com",
		"portal.staloysius.in",
		"portal.acuonline.edu.in",

		// CFS STUDENT PORTALS
		"cfs.usdcglobal.com",
		"portal.cfs.onlinejain.com",

		// QA Referral PORTALS
		"qa.jntu.referral.thekaios.com",

		// UAT Referral PORTALS
		"uat.stanford.referral.thekaios.com",
		"uat.hogwarts.referral.thekaios.com",

		// PROD Referral PORTALS
		"referral.humversity.usdcglobal.com",
	],
	ams_dashboard_origins: [
		// QA AMS DASHBOARD
		"qa.ams.dashboard.thekaios.com",

		// UAT AMS DASHBOARD
		"uat.ams.dashboard.thekaios.com",

		// PROD AMS DASHBOARD
		"ams.dashboard.usdcglobal.com",

		// CFS AMS DASHBOARD
		"cfs.dashboard.usdcglobal.com",
		"cfs.dashboard.onlinejain.com",
	],
}

export const USER_STORAGE_NAME = "_student_user_" // please sync this with student portal
export const PER_SEMESTER = "PER_SEMESTER"
export const PER_YEAR = "PER_YEAR"
export const ONE_TIME = "ONE_TIME"
export const APPLICATION_COMPLETED_STATUS = "COMPLETED"
export const PAYMENT_REGISTRATION_CATEGORY = "APPLICATION"
export const PAYMENT_PROGRAM_CATEGORY = "TUITION"
export const SAARC_COUNTRIES = [
	"Afghanistan",
	"Bangladesh",
	"Bhutan",
	"Maldives",
	"Nepal",
	"Pakistan",
	"Sri Lanka",
]


export const FORM_RENDERER_CONTAINER_ID = "form-renderer-container"
const CONFIG : {
    [key in "QA" | "UAT" | "PROD" | "PARTNER_PROD"]: {
        API_URL: string
        PAYMENT_PLANS_PER_UNIVERSITY: {
            [universityId: string]: string[]
        }
    }
} = {
	QA: {
		API_URL: "https://qa.ams.server.thekaios.com/api/v1/student-portal/",
		PAYMENT_PLANS_PER_UNIVERSITY: {
			"68ddbe2c-b35b-4d93-9d88-c6d8f8b5f205": ["PER_YEAR"],
		},
	},
	UAT: {
		API_URL: "https://uat.ams.server.thekaios.com/api/v1/student-portal/",
		PAYMENT_PLANS_PER_UNIVERSITY: {
			"4634b99c-e921-4b4f-9336-b40fe55a92c2": ["PER_YEAR"],
		},
	},
	PROD: {
		API_URL: "https://ams.server.usdcglobal.com/api/v1/student-portal/",
		PAYMENT_PLANS_PER_UNIVERSITY: {
			"68ddbe2c-b35b-4d93-9d88-c6d8f8b5f205": ["PER_YEAR"],
		},
	},
	PARTNER_PROD: {
		API_URL: "https://cfs.dashboard.usdcglobal.com/api/v1/student-portal/",
		PAYMENT_PLANS_PER_UNIVERSITY: {
			"68ddbe2c-b35b-4d93-9d88-c6d8f8b5f205": ["PER_YEAR"],
		},
	},
} as const

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case "production":
			return "PROD"
		case "staging":
			return "UAT"
		case "partner-prod":
			return "PARTNER_PROD"
		default:
			return "QA"
	}
}

const getApiUrl = () => {
	// If it is a testing widgetApp, then use the Unauthenticated API
	if (window.location.href.includes("widgetapp")) {
		return CONFIG[ENV].API_URL
	}

	// now check if the hostname is present in the student portal origins list, then use the authenticated API
	// else use the unauthenticated API
	const hostname = window.location.hostname
	const studentPortalOrigins = API_CONFIG.student_dashboard_origins
	logger.debug("Hostname of form-render is:", hostname)
	logger.debug("Student portal origins are:", studentPortalOrigins)
	if (studentPortalOrigins.includes(hostname)) {
		logger.debug("Hostname is present in student portal origins list")
		return "/api/v1/student-portal/"
	} else {
		logger.debug("Hostname is not present in student portal origins list")
		return CONFIG[ENV].API_URL
	}
}

const getReferraApiUrl = () => {
	// If it is a testing widgetApp, then use the Unauthenticated API
	if (window.location.href.includes("widgetapp")) {
		return CONFIG[ENV].API_URL
	}

	// now check if the hostname is present in the student portal origins list, then use the authenticated API
	// else use the unauthenticated API
	const hostname = window.location.hostname
	const studentPortalOrigins = API_CONFIG.student_dashboard_origins
	if (studentPortalOrigins.includes(hostname)) {
		return "/api/v1/referral-portal/"
	} else {
		return CONFIG[ENV].API_URL.replace("student", "referral")
	}
}

export const ENV = getEnv()
export const API_URL = getApiUrl()
export const AMS_API_URL = "/api/v1/"
export const IS_AMS_DASHBOARD = API_CONFIG.ams_dashboard_origins.includes(
	window.location.hostname,
)
export const REFERRAL_API_URL = getReferraApiUrl()
export const PAYMENT_PLANS_PER_UNIVERSITY = CONFIG[ENV].PAYMENT_PLANS_PER_UNIVERSITY
logger.debug("Environment of form-render is:", ENV)
